import { Component, Inject, Input, OnInit } from '@angular/core';
import { HColor } from '@shared/src/datatypes/HColor';
import { HHourIntervals } from '@shared/src/datatypes/HHourIntervals';
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { HDateHour } from '@shared/src/datatypes/HDateHour';
import { TruckingRouteDto } from '@shared/src/dtos/trucking/TruckingRouteDto';
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';

@Component({
    selector: 'shared-trucking-route-header',
    templateUrl: './shared.trucking.route.header.html',
    styleUrls: ['./shared.trucking.route.header.scss']
})
export class SharedTruckingRouteHeader implements OnInit {

    constructor(@Inject('HomeController') protected homeController: HomeController,
        public truckingController: TruckingController) {

    }

    private _route: TruckingRouteDto;
    @Input()
    public set route(value: TruckingRouteDto) {
        if (this._route === value)
            return;
        this._route = value;
    }
    public get route(): TruckingRouteDto {
        return this._route
    }

    ngOnInit(): void { }

    getTagColor(tag: string): string {
        return HColor.getColorFromStringTable(tag, this.homeController);
    }

    dateIsNull(d: HDateHour): Boolean {
        return HDateHour.isNullOrNullValue(d);
    }

    datesAreEqual(a: HDateHour, b: HDateHour): boolean {
        return HDateHour.equals(a, b);
    }

    intervalIsNull(i: HHourIntervals): boolean {
        return HHourIntervals.isNullOrNullValue(i);
    }



    pretty(value) {
        return JSON.stringify(value);
    }
}
